webpackJsonp([53468454257255],{

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.stopwatchScxml = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scxml = __webpack_require__(28);
	
	var _scxml2 = _interopRequireDefault(_scxml);
	
	var _schviz = __webpack_require__(13);
	
	var _schviz2 = _interopRequireDefault(_schviz);
	
	var _stopwatchPanel = __webpack_require__(398);
	
	var _stopwatchPanel2 = _interopRequireDefault(_stopwatchPanel);
	
	var _stopwatch = __webpack_require__(895);
	
	var _stopwatch2 = _interopRequireDefault(_stopwatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.stopwatchScxml = _stopwatch2.default;
	
	
	var initialDisplay = {
	  ElapsedMS: '00:00',
	  LapMS: '00:00',
	  LapCount: 0
	};
	
	var StopWatchExample = function (_React$Component) {
	  _inherits(StopWatchExample, _React$Component);
	
	  function StopWatchExample(props) {
	    _classCallCheck(this, StopWatchExample);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.timeouts = {};
	    _this.state = {
	      display: initialDisplay,
	      laps: []
	    };
	    return _this;
	  }
	
	  StopWatchExample.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    _scxml2.default.documentStringToModel(null, _stopwatch2.default, function (err, model) {
	      if (err) throw err;
	      model.prepare(function (err, modelFactory) {
	        if (err) throw err;
	
	        _this2.sc = new _scxml2.default.scion.Statechart(modelFactory, {
	          customSend: _this2.customSend.bind(_this2),
	          customCancel: _this2.customCancel.bind(_this2)
	        });
	
	        var transitionsEnabled = void 0;
	        _this2.sc.on('onBigStepBegin', function () {
	          transitionsEnabled = new Map();
	        });
	        _this2.sc.on('onBigStepEnd', function () {
	          var configuration = _this2.sc.getFullConfiguration();
	          _this2.setState({ configuration: configuration, transitionsEnabled: transitionsEnabled });
	        });
	        _this2.sc.on('onTransition', function (transitionSourceId, targetIds, transitionIndex) {
	          if (transitionsEnabled.has(transitionSourceId)) {
	            transitionsEnabled.get(transitionSourceId).add(transitionIndex);
	          } else {
	            transitionsEnabled.set(transitionSourceId, new Set([transitionIndex]));
	          }
	        });
	        _this2.sc.start();
	      });
	    });
	  };
	
	  StopWatchExample.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _this3 = this;
	
	    Object.keys(this.timeouts).forEach(function (sendid) {
	      return _this3.customCancel(sendid);
	    });
	  };
	
	  StopWatchExample.prototype.customSend = function customSend(event, options) {
	    var _this4 = this;
	
	    var send = function send() {
	      if (event.name === 'out.display') {
	        _this4.updateDisplay(event.data || initialDisplay);
	      } else {
	        _this4.sc.gen(event);
	      }
	    };
	
	    if (options && options.delay) {
	      this.timeouts[event.sendid] = setTimeout(send, options.delay);
	    } else {
	      send();
	    }
	  };
	
	  StopWatchExample.prototype.customCancel = function customCancel(sendid) {
	    clearTimeout(this.timeouts[sendid]);
	    delete this.timeouts[sendid];
	  };
	
	  StopWatchExample.prototype.updateDisplay = function updateDisplay(display) {
	    this.setState(function (_ref) {
	      var laps = _ref.laps;
	
	      var lapCount = display.LapCount || 0;
	      if (lapCount === 0) {
	        return { display: display, laps: [] };
	      }
	
	      var nextLaps = laps.slice();
	      if (nextLaps.length !== lapCount + 1) {
	        if (lapCount === 1 && nextLaps.length === 0) {
	          nextLaps.unshift({
	            lapIndex: 1,
	            startTime: '00:00.000',
	            endTime: display.ElapsedMS
	          });
	        }
	        nextLaps.unshift({
	          lapIndex: lapCount + 1,
	          startTime: display.ElapsedMS,
	          endTime: '00:00.000'
	        });
	      } else if (nextLaps.length > 1) {
	        nextLaps[0] = _extends({}, nextLaps[0], { endTime: display.LapMS });
	      }
	
	      return { display: display, laps: nextLaps };
	    });
	  };
	
	  StopWatchExample.prototype.render = function render() {
	    var _this5 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'row', style: { minHeight: '520px' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-8', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '520px', width: '100%', position: 'relative', border: '1px solid #eee' } },
	          _react2.default.createElement(_schviz2.default, {
	            scxmlDocumentString: _stopwatch2.default,
	            disableAnimation: true,
	            configuration: this.state && this.state.configuration,
	            disableZoomAnimation: true,
	            transitionsEnabled: this.state && this.state.transitionsEnabled,
	            expandAllStatesByDefault: true,
	            layoutOptions: _schviz2.default.layouts.auto,
	            id: 'stopwatch-example'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-4', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '520px', border: '1px solid #eee' } },
	          _react2.default.createElement(_stopwatchPanel2.default, {
	            configuration: this.state.configuration,
	            display: this.state.display,
	            laps: this.state.laps,
	            onButton1: function onButton1() {
	              return _this5.sc && _this5.sc.gen('button.1');
	            },
	            onButton2: function onButton2() {
	              return _this5.sc && _this5.sc.gen('button.2');
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return StopWatchExample;
	}(_react2.default.Component);
	
	exports.default = StopWatchExample;

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lapDuration = function lapDuration(startTime, endTime) {
	  return startTime + ' - ' + endTime;
	};
	
	var StopWatchPanel = function StopWatchPanel(_ref) {
	  var configuration = _ref.configuration,
	      display = _ref.display,
	      laps = _ref.laps,
	      onButton1 = _ref.onButton1,
	      onButton2 = _ref.onButton2;
	
	  var states = configuration || [];
	  var isReady = states.indexOf('ready') > -1;
	  var isActive = states.indexOf('active') > -1;
	  var isPaused = states.indexOf('pause') > -1;
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', padding: '1rem', background: '#f6f6f6' } },
	    _react2.default.createElement(
	      'div',
	      { style: { minHeight: '16rem', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' } },
	      _react2.default.createElement(
	        'div',
	        { style: { fontFamily: 'monospace', fontSize: '3rem', lineHeight: '3.25rem' } },
	        display.ElapsedMS
	      ),
	      !isReady && _react2.default.createElement(
	        'div',
	        { style: { fontFamily: 'monospace', fontSize: '1.25rem', color: '#666' } },
	        display.LapMS
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { marginTop: '1rem', textTransform: 'uppercase', letterSpacing: '0.08em', color: '#777' } },
	        isReady ? 'ready' : isActive ? 'running' : isPaused ? 'paused' : 'loading'
	      )
	    ),
	    laps.length > 0 && _react2.default.createElement(
	      'div',
	      { style: { maxHeight: '14rem', overflow: 'auto', marginBottom: '1rem' } },
	      laps.map(function (lap) {
	        return _react2.default.createElement(
	          'div',
	          { key: lap.lapIndex, style: { display: 'flex', justifyContent: 'space-between', padding: '0.35rem 0', borderBottom: '1px solid #ddd' } },
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Lap ',
	            lap.lapIndex
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: { fontFamily: 'monospace' } },
	            lapDuration(lap.startTime, lap.endTime)
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { display: 'flex' } },
	      _react2.default.createElement(
	        'button',
	        {
	          className: isActive ? 'btn btn-danger' : 'btn btn-success',
	          style: { flex: 1, marginRight: '0.5rem', height: '3rem' },
	          onClick: onButton1
	        },
	        isReady ? 'Start' : isActive ? 'Pause' : 'Resume'
	      ),
	      !isReady && _react2.default.createElement(
	        'button',
	        {
	          className: isActive ? 'btn btn-info' : 'btn btn-primary',
	          style: { flex: 1, height: '3rem' },
	          onClick: onButton2
	        },
	        isActive ? 'Lap' : 'Reset'
	      )
	    )
	  );
	};
	
	exports.default = StopWatchPanel;
	module.exports = exports['default'];

/***/ }),

/***/ 895:
/***/ (function(module, exports) {

	module.exports = "<scxml datamodel=\"ecmascript\"\n       initial=\"ready\"\n       name=\"ScxmlStopWatch\"\n       version=\"1.0\"\n       xmlns=\"http://www.w3.org/2005/07/scxml\">\n  <datamodel>\n    <data expr=\"100\" id=\"i_UPDATE_DELAY_MS\"/>\n  </datamodel>\n\n  <script><![CDATA[\nfunction FormatTimeStr(ms) {\n    function pad(number) {\n      if (number < 10) {\n        return '0' + number;\n      }\n      return number;\n    }\n\n    var time = new Date(ms)\n    var days = time.getUTCDate()\n    var hours = time.getUTCHours()\n    var minutes = time.getUTCMinutes()\n    var seconds = time.getUTCSeconds()\n    var milliseconds = time.getUTCMilliseconds()\n\n    var t = []\n    if (days > 1)\n        t.push(pad(days - 1) + 'T')\n\n    if (hours > 0 || t.length > 0)\n        t.push(pad(hours) + ':')\n\n    t.push(pad(minutes) + ':')\n    t.push(pad(seconds))\n\n    if (milliseconds > 0)\n        t.push('.' + (time.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5))\n\n    return t.join('')\n}\n\nfunction StopWatchClass() {\n    var timeMS = undefined\n    var pauseTimeMS = undefined\n    var pauseDurationMS = 0\n\n    this.start = function() {\n        this.reset()\n        timeMS = Date.now()\n    }\n\n    this.suspend = function() {\n        pauseTimeMS = Date.now()\n    }\n\n    this.resume = function() {\n        pauseDurationMS += Date.now() - pauseTimeMS\n        pauseTimeMS = undefined\n    }\n\n    this.reset = function() {\n        timeMS = undefined\n        pauseTimeMS = undefined\n        pauseDurationMS = 0\n    }\n\n    this.elapsed = function() {\n        return timeMS !== undefined ?\n            ((pauseTimeMS !== undefined ? pauseTimeMS : Date.now()) - timeMS - pauseDurationMS) : 0\n    }\n}\n\nvar Timer = new StopWatchClass()\nvar iLapCount = 0\nvar iLapElapsed = 0\n  ]]></script>\n\n  <state id=\"stopWatch\" initial=\"ready\">\n    <transition event=\"display\">\n      <send event=\"out.display\">\n        <param expr=\"FormatTimeStr(Timer.elapsed())\" name=\"ElapsedMS\"/>\n        <param expr=\"FormatTimeStr(Timer.elapsed() - iLapElapsed)\" name=\"LapMS\"/>\n        <param expr=\"iLapCount\" name=\"LapCount\"/>\n      </send>\n    </transition>\n\n    <state id=\"ready\">\n      <onentry>\n        <script><![CDATA[\niLapElapsed = 0\niLapCount = 0\n        ]]></script>\n        <raise event=\"display\"/>\n      </onentry>\n      <transition event=\"button.1\" target=\"active\">\n        <script>Timer.start()</script>\n      </transition>\n    </state>\n\n    <state id=\"active\">\n      <transition event=\"button.1\" target=\"pause\">\n        <script>Timer.suspend()</script>\n      </transition>\n      <state id=\"generator\">\n        <onentry>\n          <raise event=\"display\"/>\n          <send delayexpr=\"i_UPDATE_DELAY_MS + 'ms'\" event=\"update\" id=\"ID.update\"/>\n        </onentry>\n        <onexit>\n          <cancel sendid=\"ID.update\"/>\n        </onexit>\n        <transition event=\"update\" target=\"generator\"/>\n        <transition event=\"button.2\" target=\"generator\">\n          <script><![CDATA[\niLapElapsed = Timer.elapsed()\niLapCount++\n          ]]></script>\n        </transition>\n      </state>\n    </state>\n\n    <state id=\"pause\">\n      <onentry>\n        <raise event=\"display\"/>\n      </onentry>\n      <transition event=\"button.1\" target=\"active\">\n        <script>Timer.resume()</script>\n      </transition>\n      <transition event=\"button.2\" target=\"ready\">\n        <script>Timer.reset()</script>\n      </transition>\n    </state>\n  </state>\n</scxml>\n"

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _prismjs = __webpack_require__(38);
	
	var _prismjs2 = _interopRequireDefault(_prismjs);
	
	var _reactPrism = __webpack_require__(22);
	
	var _reactPrism2 = _interopRequireDefault(_reactPrism);
	
	var _TutorialPageWrapper = __webpack_require__(18);
	
	var _TutorialPageWrapper2 = _interopRequireDefault(_TutorialPageWrapper);
	
	var _stopwatchExample = __webpack_require__(397);
	
	var _stopwatchExample2 = _interopRequireDefault(_stopwatchExample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var StopWatch = function StopWatch(_ref) {
	  var sectionName = _ref.sectionName,
	      by = _ref.by;
	  return React.createElement(
	    'div',
	    null,
	    React.createElement(
	      'h1',
	      null,
	      sectionName
	    ),
	    React.createElement(
	      'h6',
	      null,
	      by
	    ),
	    React.createElement(
	      'p',
	      null,
	      'This ports Alex Zhornyak\'s Qt QML SCXML stopwatch example into a browser executable SCION example. The statechart handles start, pause, resume, reset, lap capture, and scheduled display updates.'
	    ),
	    React.createElement(_stopwatchExample2.default, null),
	    React.createElement(
	      'h2',
	      null,
	      'SCXML source'
	    ),
	    React.createElement(
	      _reactPrism2.default,
	      { component: 'pre', className: 'language-xml' },
	      _stopwatchExample.stopwatchScxml
	    )
	  );
	};
	
	var WrappedStopWatch = function WrappedStopWatch(_ref2) {
	  var location = _ref2.location;
	  return React.createElement(_TutorialPageWrapper2.default, { Component: StopWatch, pathname: location.pathname });
	};
	
	exports.default = WrappedStopWatch;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutorials-examples-stopwatch-js-d415b9302b8e181d4e99.js